import React from "react";
import WhatsAppCta from "./WhatsAppCta";
import FotoLeadForm from "./FotoLeadForm";

const FotoCtaFinal = ({ segmento }) => (
  <section id="reservar" className="bg-sand-50 py-20 md:py-28">
    <div className="container-page grid gap-12 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:items-start">
      <div>
        <h2 className="section-title">Pide fecha.</h2>
        <p className="section-copy mt-5 max-w-md">
          {segmento
            ? `${segmento.entrega} de entrega. Factura. ${segmento.promesa}`
            : "Eventos y fotos en estudio. Precio publicado y factura."}
        </p>
        <WhatsAppCta
          message={segmento?.whatsapp || "Hola Omega, quiero cotizar una sesión de fotos."}
          location="cta_final"
          variant="dark"
          className="mt-8"
        >
          Escribir por WhatsApp
        </WhatsAppCta>
      </div>
      <div className="rounded-3xl border border-navy-100 bg-white p-6 shadow-card sm:p-8">
        <FotoLeadForm segmento={segmento} />
      </div>
    </div>
  </section>
);

export default FotoCtaFinal;
